import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import StageBackground from '../../DeviationBackground/StageBackground';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import s from './CommissionStage.scss';

export interface Props {
  deviation: PapiDeviation;
}

const CommissionStage: React.FC<Props> = ({ deviation }) => {
  return (
    <div className={s['root']}>
      <StageBackground deviation={deviation} />
      <DeviationFullView deviation={deviation} />
      <DuperbrowsePaddles className={s['duperbrowse']} />
    </div>
  );
};
CommissionStage.displayName = 'CommissionStage';

export default CommissionStage;
